import { Column } from '@miq/catalog';
import {
  ConfidentialityTypeMap,
  GroupPermissionFields,
  permissionLevelMap,
  PropertyUsageTypesMap,
  UserPermissionFields,
} from './permission';

export interface DataObject {
  [key: string]: any;
}

export type PermissionColumn = Partial<Column>;

export const GROUP_COLUMNS: PermissionColumn[] = [
  {
    columnId: 2,
    header: 'Role',
    field: GroupPermissionFields.Role,
    dataType: 'text',
    inputType: 'dropdown',
    pinned: true,
    displayFn: (rowData: DataObject) => {
      return rowData.role_desc;
    },
    isDisabled: false,
  },
  {
    columnId: 3,
    header: 'Global Region',
    field: GroupPermissionFields.GlobalRegion,
    sortable: true,
    dataType: 'text',
    inputType: 'dropdown',
    displayFn: (rowData: DataObject) => {
      return rowData.region_id != null && rowData.region_id !== 0 ? rowData.region_desc : 'ALL';
    },
    isDisabled: false,
  },
  {
    columnId: 4,
    header: 'Division',
    field: GroupPermissionFields.Division,
    sortable: true,
    dataType: 'text',
    inputType: 'dropdown',
    displayFn: (rowData: DataObject) => {
      return rowData.division_id != null && rowData.division_id !== 0 ? rowData.division_desc : 'ALL';
    },
    // division to start enabled as Global Region will have "Americas" by default
    isDisabled: false,
  },
  {
    columnId: 5,
    header: 'Market',
    field: GroupPermissionFields.Market,
    sortable: true,
    dataType: 'text',
    inputType: 'dropdown',
    displayFn: (rowData: DataObject) => {
      return rowData.market_id != null && rowData.market_id !== 0 ? rowData.market_desc : 'ALL';
    },
    isDisabled: true,
  },
  {
    columnId: 6,
    header: 'Property Type',
    field: GroupPermissionFields.PropertyType,
    sortable: true,
    displayFn: (rowData: DataObject) => {
      return rowData.usage_type_id != null ? PropertyUsageTypesMap[rowData.usage_type_id] : '';
    },
    dataType: 'text',
    inputType: 'dropdown',
    isDisabled: false,
  },
  {
    columnId: 7,
    header: 'Confidentiality Level',
    field: GroupPermissionFields.ConfidentialityLevel,
    sortable: true,
    displayFn: (rowData: DataObject) => {
      return rowData.confidentiality_type_id ? ConfidentialityTypeMap[rowData.confidentiality_type_id] : '';
    },
    dataType: 'text',
    inputType: 'dropdown',
    isDisabled: false,
  },
  {
    columnId: 8,
    header: 'Permission Level',
    field: GroupPermissionFields.PermissionLevel,
    sortable: true,
    displayFn: (rowData: DataObject) => {
      return rowData.level ? permissionLevelMap[rowData.level] : '';
    },
    dataType: 'text',
    inputType: 'dropdown',
    values: Object.entries(permissionLevelMap).map(([key, value]) => ({ key: Number(key), value })),
    isDisabled: false,
  },
];

export const USERS_COLUMNS: PermissionColumn[] = [
  {
    columnId: 3,
    header: 'User Name',
    field: UserPermissionFields.UserName,
    sortable: true,
    pinned: true,
    dataType: 'text',
    inputType: 'autoComplete',
    isDisabled: false,
  },
  {
    columnId: 4,
    header: 'Email',
    field: UserPermissionFields.Email,
    sortable: true,
    dataType: 'text',
    inputType: 'Text',
    isDisabled: true,
  },
  {
    columnId: 5,
    header: 'Permission Level',
    field: UserPermissionFields.PermissionLevel,
    sortable: true,
    displayFn: (rowData: DataObject) => {
      return rowData.level ? permissionLevelMap[rowData.level] : '';
    },
    dataType: 'text',
    inputType: 'dropdown',
    values: Object.entries(permissionLevelMap).map(([key, value]) => ({ key: Number(key), value })),
  },
];

export interface Permission {
  id: number;
  entity_id: number;
  type: string;
  level: number;
  user_id: number;
  user_email: string;
  user_name: string;
  role_id: number | null;
  region_id: number | null;
  region_desc: string | null;
  division_id: number | null;
  division_desc: string | null;
  market_id: number | null;
  market_desc: string | null;
  usage_type_id: number | null;
  confidentiality_type_id: number | null;
}
